const doc = [({"da":({"js":({"admin":({"roles":({"abilities":({"abilities_for":"Adgange for %{role}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;